<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-order">
    <mat-card-header>
       
      </mat-card-header>    
    <mat-card-content>

        <ng-container *ngIf="this.isProcessing === true">
            <div class="d-flex justify-content-center" style="margin-top:20px;margin-bottom:20px;">
                    <span style="font-size:24px;font-weight:bold">Please stand by while we update the Additional Vehicles...</span>
            </div>  
        </ng-container>

        <ng-container *ngIf="this.updateVehicleMode === false && this.isProcessing === false">
            <span style="margin-left: 0px;margin-top:20px;"  class="lanai-page-title">Add Additional Vehicle</span>
        <form 
        (ngSubmit)="onSubmitAddNewVehicle()" 
        novalidate
        [formGroup]="vehicleForm" 
        
        style="margin-top:20px;">
        <div class="row margin-top:20px;">
            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label>Vehicle License Plate</mat-label>
                    <input matInput placeholder="Vehicle License Plate" maxlength="16" formControlName="additionalVehicleLicensePlate" 
                        (keypress)="keyPressAlphanumeric($event)" autocomplete="chrome-off"  >
                    <mat-error>The license plate is required</mat-error>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label>Vehicle Make</mat-label>
                    <input matInput placeholder="Vehicle Make"  formControlName="additionalVehicleMake" autocomplete="chrome-off"  (keydown)="onKeyDown($event)">
                  </mat-form-field>
            </div>
            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label>Vehicle Model</mat-label>
                    <input matInput placeholder="vehicleModel" formControlName="additionalVehicleModel" autocomplete="chrome-off"  (keydown)="onKeyDown($event)">
                  </mat-form-field>
            </div>
            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label>Vehicle Color</mat-label>
                    <input matInput placeholder="vehicleColor" formControlName="additionalVehicleColor" autocomplete="chrome-off"  (keydown)="onKeyDown($event)">
                  </mat-form-field>
            </div>

            <div class="col-2">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
                <mat-label>Vehicle State</mat-label>
                <mat-select matNativeControl formControlName="additionalVehicleState">
                  <mat-option value="">Select State of Vehicle</mat-option>
                  <mat-option *ngFor="let state of additionalVehicleStates" [value]="state.stateAbbreviation" >
                    {{state.stateFullName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-2">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Enforcement Sub-Lot</mat-label>
                        <input matInput placeholder="Enforcement Sub-Lot" formControlName="vehicleEnforcementSubLot" autocomplete="chrome-off"  (keydown)="onKeyDown($event)">
                        <mat-error *ngIf="vehicleForm.controls['vehicleEnforcementSubLot'].hasError('pattern')">Enter up to 10 comma-separated sub lots, each 1-6 alphanumeric characters. Spaces between sub lots are allowed (e.g. 555A, 65778B).</mat-error>
                    </mat-form-field>
            </div>
        </div>
      
        <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!vehicleForm.valid">Submit</button>
        <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="onResetAdditionalVehicleData()">Clear</button>
        </form>
    </ng-container>
        <div style="margin-top:20px;"></div>


<ng-container *ngIf="additionalVehicles.length > 0 && this.isProcessing === false">

    <igx-grid  [batchEditing]="true" #gridProfile [data]="this.additionalVehicles" [width]="'99%'" [height]="'400px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:20px;
    paste-handler  [primaryKey]="'additionalVehicleId'" [rowEditable]="false"
    [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
    [emptyGridMessage]="'No Additional Contacts for Companyy'" >


    <igx-column field="" header=" " [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true">
        <ng-template #compositeTemp igxCell let-cell="cell">
            <!-- 20260217 :: Ken Moss - Removed per Josh Izigzon.  
            Removed ability to edit an existing vehicle.
            On refactor to new spACE Portal endoints, removed the parker from the Parker Profile, added a vehicle history log that tracks adds/delets.
            Per Josh, users should delete a vehicle and then add it back in if they need to change any details on an existing vehicle.  
            Log enables (AcePark table: Log_AdditionalVehicle) spACE-AR to maintain a history of changes to the parker's vehicles. -->
            <!-- <button mat-icon-button aria-label="Edit Contact" (click)="onEnableVehicleEditMode(cell.row.data.vehicleId)" matTooltip="Edit Contact">
                <mat-icon>edit</mat-icon>
            </button> -->
            <button mat-icon-button aria-label="Delete Contact" (click)="onDeleteVehicle(cell.row.data.vehicleId)" matTooltip="Delete Contact" style="margin-left:20px;">
                <mat-icon>delete</mat-icon>
            </button>
        </ng-template>
    </igx-column>

<igx-column header="Date Added" field="dateEntered" [sortable]="true" width="150px" required style="font-size:10px;" [resizable]="true">
  <ng-template igxCell let-value>
    {{ value | date:'MM/dd/yyyy' }}
  </ng-template>
</igx-column>

    <igx-column field="vehicleLicense" header="License Plate" [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="vehicleMake" header="Make" [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="vehicleModel" header="Model" [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="vehicleColor" header="Color" [sortable]="true" width="125px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="vehicleState" header="State" [sortable]="true" width="100px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="userName" header="User Name" [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true"></igx-column>
    <igx-column field="vehicleEnforcementSubLot" header="Enforcement Sub Lot" [sortable]="true" width="275px" required style="font-size:10px;"  [resizable]="true"></igx-column>

  <igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

    </igx-grid>

</ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    <hr />

  </mat-card-actions>



</mat-card>

